/**
 * Collection Filters Sticky Offset
 * Adjusts the sticky filter bar position based on header visibility
 */
(function() {
  'use strict';

  function initCollectionFiltersSticky() {
    const filterBar = document.getElementById('main-collection-filters');
    const header = document.querySelector('.section-header');
    const stickyHeader = document.querySelector('sticky-header');
    
    if (!filterBar || !header) return;

    function updateFilterBarPosition() {
      // Check if header is visible and sticky
      const isHeaderSticky = header.classList.contains('shopify-section-header-sticky');
      const isHeaderHidden = header.classList.contains('shopify-section-header-hidden');
      
      if (isHeaderSticky && !isHeaderHidden) {
        // Header is visible - position filter bar below it
        // Use CSS variable if available, otherwise calculate height
        const headerHeightVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        let headerHeight;
        
        if (headerHeightVar) {
          // Remove 'px' and convert to number
          headerHeight = parseFloat(headerHeightVar.trim());
        } else {
          // Fallback to actual height
          headerHeight = header.offsetHeight;
        }
        
        filterBar.style.top = `${headerHeight - 1}px`;
      } else {
        // Header is hidden or not sticky - position filter bar at top
        filterBar.style.top = '0';
      }
    }

    // Initial update
    updateFilterBarPosition();

    // Watch for header class changes using MutationObserver
    const headerObserver = new MutationObserver(() => {
      updateFilterBarPosition();
    });

    headerObserver.observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Also listen to scroll events to handle rapid changes
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateFilterBarPosition();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Handle window resize (header height might change)
    window.addEventListener('resize', () => {
      updateFilterBarPosition();
    });

    // If sticky header element exists, also watch for its height changes
    if (stickyHeader) {
      const stickyHeaderObserver = new MutationObserver(() => {
        updateFilterBarPosition();
      });

      stickyHeaderObserver.observe(stickyHeader, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFiltersSticky);
  } else {
    initCollectionFiltersSticky();
  }
})();

